// extracted by mini-css-extract-plugin
export default {"lottieContainer":"LessonLottie_lottieContainer__Ky1vI","lottie":"LessonLottie_lottie__Hyzlj","praise":"LessonLottie_praise__Cz+Uw"};